export const isDev = () => window.location.hostname === 'localhost';
